<template>
  <a-card size="small">
    <template #title>待选列表 - {{ value.length }}项</template>
    <template #extra>
      <a-button size="small" type="link" @click="remove">删除选中</a-button>
    </template>

    <table-wrapper
      row-key="id"
      size="small"
      :bordered="true"
      :data-source="value"
      :columns="columns"
      @onSelectionChange="onSelectionChange"
      @change="onTableChange"
      :tableHeight="tableHeight-20"
    >
    </table-wrapper>
  </a-card>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs } from "vue";
import { columns } from "./constant";
import { LibraryListRecord } from "@/views/material/library/library.interface";

export default defineComponent({
  name: "SelectedTable",
  props: {
    value: {
      type: Array as PropType<LibraryListRecord[]>,
      default: [],
    },tableHeight:{
      type:Number,
      default:()=>{
        return {}
      }
    }
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      current: number;
      selectedIds: string[];
      columns: any[];
    }>({
      current: 1,
      selectedIds: [],
      columns,
    });

    const onSelectionChange = (ids: string[]) => {
      state.selectedIds = ids;
    };

    const onTableChange = async (pagination) => {
      state.current = pagination.current;
    };

    const remove = () => {
      const newValue = (props.value || []).filter((item) => !state.selectedIds.includes(item.id));
      emit("update:value", newValue);
    };

    return {
      ...toRefs(state),
      onSelectionChange,
      onTableChange,
      remove,
    };
  },
});
</script>
